import React, { useState, useRef, useEffect, useCallback } from 'react';

interface NavDropdownItem {
  label: string;
  href: string;
}

interface NavDropdownProps {
  trigger: string;
  items: NavDropdownItem[];
}

export function NavDropdown({ trigger, items }: NavDropdownProps) {
  const [open, setOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const clearCloseTimeout = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  }, []);

  function handleMouseEnter() {
    clearCloseTimeout();
    setOpen(true);
  }

  function handleMouseLeave() {
    timeoutRef.current = setTimeout(() => setOpen(false), 150);
  }

  useEffect(() => clearCloseTimeout, [clearCloseTimeout]);

  return (
    <div
      ref={containerRef}
      className="site-nav-link-slot relative"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="site-nav-link"
      >
        {trigger}
      </button>

      {open && (
        <div className="absolute top-full left-0 mt-2 flex min-w-dropdown flex-col gap-3 rounded-comfortable bg-surface-panel px-4 py-5 shadow-elevated">
          {items.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="text-caption-lg text-text-primary transition-colors hover:text-text-secondary"
              onClick={() => setOpen(false)}
            >
              {item.label}
            </a>
          ))}
        </div>
      )}
    </div>
  );
}
